const TokenKey = 'bdwatch_training'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js